import request from './request'

// 手机登录发送验证码
export function sendCode(params) {
    return request({
        url: '/code',
        method: 'GET',
        params
    })
}
// 手机验证码登录
export function loginByCode(data) {
    return request({
        url: '/login',
        method: 'POST',
        data
    })
}


// 手机密码登录
export function loginByPasswd(data) {
    return request({
        url: '/login',
        method: 'POST',
        data
    })
}

// 选择角色
export function selectRole(params) {
    return request({
        url: '/role/select',
        method: 'POST',
        params
    })
}

// 获取许愿列表
export function wishList(params) {
    return request({
        url: '/wish',
        method: 'GET',
        params
    })
}

// 许愿
export function makeWish(params) {
    return request({
        url: '/wish',
        method: 'POST',
        params,
        data: params
    })
}
// 许愿的情况
export function wishSocks(params) {
    return request({
        url: '/wish/desire/detail',
        method: 'GET',
        params
    })
}

// 获取自己的许愿记录
export function myWish(params) {
    return request({
        url: '/wish/record/self',
        method: 'GET',
        params
    })
}

// 获取许愿次数
export function wishChance(params) {
    return request({
        url: '/wish/times',
        method: 'GET',
        params
    })
}

// 获取别人的愿望
export function wishRandom(params) {
    return request({
        url: '/wish/record/random',
        method: 'GET',
        params: {limit: 15, page: 1, ...params}
    })
}

// 分享
export function share(data) {
    return request({
        url: '/wish/share',
        method: 'POST',
        params: data,
        data
    })
}

